import {Component, Input, OnInit} from '@angular/core';
import {FileDownloaderService} from '../../../../components/admin/file-downloader/file-downloader.service';
import {DateService} from '../../../../services/date.service';

@Component({
  selector: 'app-proposal-preview',
  templateUrl: './proposal-preview.component.html',
  styleUrls: ['./proposal-preview.component.scss']
})
export class ProposalPreviewComponent implements OnInit {
  @Input() public proposal;

  constructor(
    public fileDownloader: FileDownloaderService,
    public dateService: DateService,
  ) {
  }

  ngOnInit(): void {
  }

  public downloadFile(file) {
    this.fileDownloader.addNewFileToDownload(file);
  }
}
